import styled from 'styled-components'

export const Container = styled.div`
  margin-bottom: 20px;
`

export const FieldRow = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 768px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`

export const HalfColumn = styled.div`
  width: 100%;
  @media (min-width: 768px) {
    flex: 0 0 49%;
    max-width: 49%;
  }
`
